
export enum CopySpeachStatus {
    PENDING='PENDING',
  ERROR='ERROR',
    SUCCESS='SUCCESS'
}
